<template lang="pug">
    .placeholder(v-if="media === undefined || error")
        i.el-icon-fa-camera.fas
    .placeholder(v-else-if="loading")
        .spinner
    .media(v-else)
        .video(v-if="type === 'video' && file")
            video(
                ref="player"
                class="video-js vjs-city-offer vjs-show-big-play-button-on-pause minimalistic"
                controls
                playsinline
                preload="auto"
                :style="{ width: `${width}px`, height: `${height}px`}"
            )
                source(:src="src" :type="file.mime")
        .image(v-else-if="type === 'image' && file")
            figure(:style="{ width: `${width}px`, height: `${height}px`}")
                img(:src="src")
</template>

<script>
import _ from 'lodash'
import videojs from 'video.js';

import AuthApi from '@/store/api/system/auth'

export default {
    name: 'POS_ItemMediaPreview',
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data: () => ({
        loading: false,
        error: false,
    }),
    computed: {
        media() {
            let media = _.get(this.item, 'article.media') || []
            if (! media.length) media = _.get(this.item, 'article.product.media') || []

            return media.find(el => el.type === 'image' && el.settings.show.list)
                || media.find(el => el.type === 'image' && el.settings.show.detail)
        },
        type() {
            return this.media.type;
        },
        file() {
            let isHLS;
            switch (this.type) {
                case 'file':
                    return _.get(this.media, 'file');

                case 'image':
                    return _.get(this.media, 'image.source');

                case 'video':
                    isHLS = !! _.get(this.media, 'video.hls')
                    if (isHLS) {
                        return _.get(this.media, 'video.hls');
                    } else {
                        return _.get(this.media, 'video.source');
                    }
            }
        },
        width() {
            // let width = 150;
            // if (['image', 'video'].includes(this.type) && this.media[this.type]) {
            //     const ratio = this.media[this.type].width / this.media[this.type].height;
            //     if (!isNaN(ratio)) width = this.height * ratio;
            // }
            // return _.round(width);
            return 60
        },
        height() {
            // return 150;
            return 80
        },
        src() {
            const storageRoute = _.trim(
                `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`,
                '/'
            );

            let fit;
            let table = 'uploads';

            let id = this.file.id;
            const name = this.file.name;

            switch (this.type) {
                case 'file':
                    if (!this.file.upload) table = 'files';
                    break;

                case 'image':
                    // const fit = 'fit=fill&w=160&h=160&fill-color=ffffff'
                    // const fit = 'fit&h=160&fill-color=ffffff'

                    fit = 'fit&h=150';

                    if (!this.file.upload) {
                        table = 'images';
                        id = this.media.image.id;
                    }
                    break;

                case 'video':
                    if (!this.file.upload) {
                        table = 'videos';
                        id = this.media.video.id;

                        const isHLS = !! _.get(this.media, 'video.hls')
                        if (isHLS) {
                            const cdnEndpoint = _.trim(
                                `${process.env.VUE_APP_CDN_ENDPOINT}${process.env.VUE_APP_CDN_ROOT || ''}`,
                                '/'
                            );

                            return `${cdnEndpoint}/${this.media.video.hls.path}/${this.media.video.hls.name}`;
                        }
                    }
                    break;
            }

            const token = AuthApi.getToken('mimic') || AuthApi.getToken();
            let src = `${storageRoute}/${table}/${id}/${name}?token=${token}`;
            if (this.type === 'image' && fit) src += `&${fit}`;

            return src;
        },
    },
    methods: {
        preloadImage() {
            let img = new Image();
            img.onload = () => {
                this.loading = false;
            };
            img.onerror = () => {
                this.error = true;
                this.loading = false;
            };
            img.src = this.src;
        }
    },
    mounted() {
        if (this.media && this.type === 'image') {
            this.loading = true
            if (this.src) this.preloadImage();
        } else if (this.$refs.player) {
            const options = {
                muted: true,
                language: 'en',
                preload: 'auto',
                fluid: false,
                html5: {
                    hls: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions: true,
                        useDevicePixelRatio: true
                        // bandwidth: 16777216,
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    useBandwidthFromLocalStorage: true
                },
                // https://docs.videojs.com/tutorial-components.html
                controlBar: {
                    PlayToggle: false,
                    RemainingTimeDisplay: false,
                    pictureInPictureToggle: false,
                    // fullscreenToggle: false,
                    volumePanel: false
                }
                // plugins: {
                //     hlsQualitySelector: {
                //         displayCurrentQuality: true,
                //     }
                // }
            };

            const video = videojs(this.$refs.player, options);
            video.httpSourceSelector();

            video.on('error', () => {
                this.error = true
            });
            video.ready(() => {
                video.tech_.off('dblclick');
            });
        }
    }
}
</script>

<style lang="sass" scoped>
.video::v-deep
    .video-js
        background: darken($color-skeleton, 10%)
    .vjs-modal-dialog-content
        display: none
    .video-js .vjs-modal-dialog
        background: none
    .video-js.vjs-city-offer .vjs-big-play-button,
    .vjs-error .vjs-error-display:before
        display: none

figure
    margin: 0
    img
        width: 100%
        height: 100%
        object-fit: cover
        border-radius: 4px
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.04), 0 3px 1px -2px rgba(0,0,0,0.02), 0 1px 5px 0 rgba(0,0,0,0.1)

.placeholder
    width: 60px
    height: 80px
    background: darken($color-skeleton, 10%)
    border-radius: 4px
    display: flex
    justify-content: center
    align-items: center
    font-size: 2rem
    // color: $color-body
    color: darken($color-skeleton, 20%)
</style>
